// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cg-wrap {
  box-sizing: content-box;
  position: relative;
  display: block;
}

cg-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  top: 0;
}

cg-board {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: 0;
  background-size: cover;
}

.cg-wrap.manipulable cg-board {
  cursor: pointer;
}

cg-board square {
  position: absolute;
  top: 0;
  left: 0;
  width: 12.5%;
  height: 12.5%;
  pointer-events: none;
}

cg-board square.move-dest {
  pointer-events: auto;
}

cg-board square.last-move {
  will-change: transform;
}

.cg-wrap piece {
  position: absolute;
  top: 0;
  left: 0;
  width: 12.5%;
  height: 12.5%;
  background-size: cover;
  z-index: 2;
  will-change: transform;
  pointer-events: none;
}

cg-board piece.dragging {
  cursor: move;
  /* !important to override z-index from 3D piece inline style */
  z-index: 11 !important;
}

piece.anim {
  z-index: 8;
}

piece.fading {
  z-index: 1;
  opacity: 0.5;
}

.cg-wrap piece.ghost {
  opacity: 0.3;
}

.cg-wrap piece svg {
  overflow: hidden;
  position: relative;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  opacity: 0.6;
}

.cg-wrap cg-auto-pieces,
.cg-wrap .cg-shapes,
.cg-wrap .cg-custom-svgs {
  overflow: visible;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.cg-wrap cg-auto-pieces {
  z-index: 2;
}

.cg-wrap cg-auto-pieces piece {
  opacity: 0.3;
}

.cg-wrap .cg-shapes {
  overflow: hidden;
  opacity: 0.6;
  z-index: 2;
}

.cg-wrap .cg-custom-svgs {
  /* over piece.anim = 8, but under piece.dragging = 11 */
  z-index: 9;
}

.cg-wrap .cg-custom-svgs svg {
  overflow: visible;
}

.cg-wrap coords {
  position: absolute;
  display: flex;
  pointer-events: none;
  opacity: 0.8;
  font-family: sans-serif;
  font-size: 9px;
}

.cg-wrap coords.ranks {
  left: 4px;
  top: -20px;
  flex-flow: column-reverse;
  height: 100%;
  width: 12px;
}

.cg-wrap coords.ranks.black {
  flex-flow: column;
}

.cg-wrap coords.ranks.left {
  left: -15px;
  align-items: flex-end;
}

.cg-wrap coords.files {
  bottom: -4px;
  left: 24px;
  flex-flow: row;
  width: 100%;
  height: 16px;
  text-transform: uppercase;
  text-align: center;
}

.cg-wrap coords.files.black {
  flex-flow: row-reverse;
}

.cg-wrap coords coord {
  flex: 1 1 auto;
}

.cg-wrap coords.ranks coord {
  transform: translateY(39%);
}

.cg-wrap coords.squares {
  bottom: 0;
  left: 0;
  text-transform: uppercase;
  text-align: right;
  flex-flow: column-reverse;
  height: 100%;
  width: 12.5%;
}

.cg-wrap coords.squares.black {
  flex-flow: column;
}

.cg-wrap coords.squares.left {
  text-align: left;
}

.cg-wrap coords.squares coord {
  padding: 6% 4%;
}

.cg-wrap coords.squares.rank2 {
  transform: translateX(100%);
}

.cg-wrap coords.squares.rank3 {
  transform: translateX(200%);
}

.cg-wrap coords.squares.rank4 {
  transform: translateX(300%);
}

.cg-wrap coords.squares.rank5 {
  transform: translateX(400%);
}

.cg-wrap coords.squares.rank6 {
  transform: translateX(500%);
}

.cg-wrap coords.squares.rank7 {
  transform: translateX(600%);
}

.cg-wrap coords.squares.rank8 {
  transform: translateX(700%);
}
`, "",{"version":3,"sources":["webpack://./node_modules/chessground/assets/chessground.base.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,8DAA8D;EAC9D,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uDAAuD;EACvD,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".cg-wrap {\n  box-sizing: content-box;\n  position: relative;\n  display: block;\n}\n\ncg-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: block;\n  top: 0;\n}\n\ncg-board {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  line-height: 0;\n  background-size: cover;\n}\n\n.cg-wrap.manipulable cg-board {\n  cursor: pointer;\n}\n\ncg-board square {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 12.5%;\n  height: 12.5%;\n  pointer-events: none;\n}\n\ncg-board square.move-dest {\n  pointer-events: auto;\n}\n\ncg-board square.last-move {\n  will-change: transform;\n}\n\n.cg-wrap piece {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 12.5%;\n  height: 12.5%;\n  background-size: cover;\n  z-index: 2;\n  will-change: transform;\n  pointer-events: none;\n}\n\ncg-board piece.dragging {\n  cursor: move;\n  /* !important to override z-index from 3D piece inline style */\n  z-index: 11 !important;\n}\n\npiece.anim {\n  z-index: 8;\n}\n\npiece.fading {\n  z-index: 1;\n  opacity: 0.5;\n}\n\n.cg-wrap piece.ghost {\n  opacity: 0.3;\n}\n\n.cg-wrap piece svg {\n  overflow: hidden;\n  position: relative;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 2;\n  opacity: 0.6;\n}\n\n.cg-wrap cg-auto-pieces,\n.cg-wrap .cg-shapes,\n.cg-wrap .cg-custom-svgs {\n  overflow: visible;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.cg-wrap cg-auto-pieces {\n  z-index: 2;\n}\n\n.cg-wrap cg-auto-pieces piece {\n  opacity: 0.3;\n}\n\n.cg-wrap .cg-shapes {\n  overflow: hidden;\n  opacity: 0.6;\n  z-index: 2;\n}\n\n.cg-wrap .cg-custom-svgs {\n  /* over piece.anim = 8, but under piece.dragging = 11 */\n  z-index: 9;\n}\n\n.cg-wrap .cg-custom-svgs svg {\n  overflow: visible;\n}\n\n.cg-wrap coords {\n  position: absolute;\n  display: flex;\n  pointer-events: none;\n  opacity: 0.8;\n  font-family: sans-serif;\n  font-size: 9px;\n}\n\n.cg-wrap coords.ranks {\n  left: 4px;\n  top: -20px;\n  flex-flow: column-reverse;\n  height: 100%;\n  width: 12px;\n}\n\n.cg-wrap coords.ranks.black {\n  flex-flow: column;\n}\n\n.cg-wrap coords.ranks.left {\n  left: -15px;\n  align-items: flex-end;\n}\n\n.cg-wrap coords.files {\n  bottom: -4px;\n  left: 24px;\n  flex-flow: row;\n  width: 100%;\n  height: 16px;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.cg-wrap coords.files.black {\n  flex-flow: row-reverse;\n}\n\n.cg-wrap coords coord {\n  flex: 1 1 auto;\n}\n\n.cg-wrap coords.ranks coord {\n  transform: translateY(39%);\n}\n\n.cg-wrap coords.squares {\n  bottom: 0;\n  left: 0;\n  text-transform: uppercase;\n  text-align: right;\n  flex-flow: column-reverse;\n  height: 100%;\n  width: 12.5%;\n}\n\n.cg-wrap coords.squares.black {\n  flex-flow: column;\n}\n\n.cg-wrap coords.squares.left {\n  text-align: left;\n}\n\n.cg-wrap coords.squares coord {\n  padding: 6% 4%;\n}\n\n.cg-wrap coords.squares.rank2 {\n  transform: translateX(100%);\n}\n\n.cg-wrap coords.squares.rank3 {\n  transform: translateX(200%);\n}\n\n.cg-wrap coords.squares.rank4 {\n  transform: translateX(300%);\n}\n\n.cg-wrap coords.squares.rank5 {\n  transform: translateX(400%);\n}\n\n.cg-wrap coords.squares.rank6 {\n  transform: translateX(500%);\n}\n\n.cg-wrap coords.squares.rank7 {\n  transform: translateX(600%);\n}\n\n.cg-wrap coords.squares.rank8 {\n  transform: translateX(700%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
